<div id="chatProgressBar"
     class="tw-bg-yellow-100 tw-sticky tw-w-full tw-left-0 tw-z-20"
     [ngClass]="stickyTopClass()">
  <div class="tw-h-2 tw-bg-yellow-500 tw-transition-all tw-duration-500 tw-ease-in-out"
       [style]="{ 'width': (progress$ | async) + '%' }"></div>
</div>
